import { CalendarIcon } from "@heroicons/react/24/outline";
import { DEFAULT_GOOD_VIBES_TIME_FRAME, type GoodVibesTimeFrame, GoodVibesTimeFrameSchema } from "@domains/good-vibes/shared/goodVibesTimeFrame.ts";
import { FilterChipSelect } from "@packages/core-client/collection/FilterChipSelect.tsx";
import { useI18nextInstance } from "@squide/i18next";
import { useCallback } from "react";
import type { Key } from "react-aria-components";
import { useTranslation } from "react-i18next";
import { SelectItem } from "@/components/ui/select.tsx";
import { i18NextInstanceKey } from "../i18n/i18next.ts";

const PERIOD_ICON = <CalendarIcon aria-hidden="true" className="size-4" />;

export interface GoodVibesTimeFrameSelectProps {
    timeFrame: GoodVibesTimeFrame;
    onTimeFrameChange: (timeFrame: GoodVibesTimeFrame) => void;
}

export function GoodVibesTimeFrameSelect({ timeFrame, onTimeFrameChange }: GoodVibesTimeFrameSelectProps) {
    const i18nextInstance = useI18nextInstance(i18NextInstanceKey);
    const { t } = useTranslation("GoodVibesTimeFrameSelect", { i18n: i18nextInstance });

    const handleSelectionChange = useCallback((key: Key) => onTimeFrameChange(GoodVibesTimeFrameSchema.catch(DEFAULT_GOOD_VIBES_TIME_FRAME).parse(key)), [onTimeFrameChange]);

    return (
        <FilterChipSelect ariaLabel={t("ariaLabel")} clearAriaLabel={t("clearAriaLabel")} selectedKey={timeFrame} defaultKey={DEFAULT_GOOD_VIBES_TIME_FRAME} onSelectionChange={handleSelectionChange} prefix={PERIOD_ICON}>
            {GoodVibesTimeFrameSchema.options.map(value => (
                <SelectItem key={value} id={value} textValue={t(`timeFrames.${value}`)}>
                    {t(`timeFrames.${value}`)}
                </SelectItem>
            ))}
        </FilterChipSelect>
    );
}
